
<div class="container" [ngClass]="{'general-disabled': isMigrationActive}">
  <md-spinner-block *ngIf="loading"></md-spinner-block>
  <div class="row justify-content-center" *ngIf="!loading">
    <div class="col table-card">
      <form>
        <div class="finish-import">
          <div class="form-group row">
            <div class="col-md-6">
              <h4>Import Options</h4>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" autoLinkToLabel [(ngModel)]="removeAssets" name="removeAssets" [disabled]="successful">
                <label class="form-check-label">Delete assets from TMC that were deleted in Portico</label>
                <ul style="cursor: default">
                  <li>Assets that were modified after being imported will be deleted.</li>
                  <li>Assets belonging to Portico/SOLD projects that are no longer associated with their site will be deleted.</li>
                  <li>Standalone accessories linked to deleted assets will also be deleted.</li>
                  <li>Assets with an order number will not be deleted.</li>
                  <li>Installed assets will not be deleted.</li>
                </ul>
              </div>
            </div>
            <div class="col-md-6">
              <button class="btn btn-primary btn-block" type="button" (click)="importDeal()" [disabled]="!finalizeVisible || successful">Add Device Data to Site</button>
              <div class="alert alert-success mt-4" *ngIf="successful">Import complete.</div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="row justify-content-center" *ngIf="!loading &amp;&amp; assetReconciliationVisible &amp;&amp; !successful">
    <div class="col table-card">
      <form>
        <div class="cdf-asset-reconciliation">
          <div class="form-group row">
            <label class="col col-form-label">Please make sure all future-fleet assets have a Device Key (<span [ngPlural]="unconfiguredAssetsCount">
                <ng-template ngPluralCase="=0"></ng-template>
                <ng-template ngPluralCase="=1">1 asset</ng-template>
                <ng-template ngPluralCase="other">{{ unconfiguredAssetsCount }} assets</ng-template></span><span *ngIf="unconfiguredAssetsCount &amp;&amp; unconfiguredAccessoriesCount"> and </span><span [ngPlural]="unconfiguredAccessoriesCount">
                <ng-template ngPluralCase="=0"></ng-template>
                <ng-template ngPluralCase="=1">1 accessory</ng-template>
                <ng-template ngPluralCase="other">{{ unconfiguredAssetsCount }} accessories</ng-template></span><span *ngIf="unconfiguredAssetsCount || unconfiguredAccessoriesCount"> not configured</span><span *ngIf="!unconfiguredAssetsCount &amp;&amp; !unconfiguredAccessoriesCount">all configured</span>):</label>
          </div>
          <div class="form-group-row">
            <div class="col">
              <asset-reconciliation [assets]="cdf.assets" (change)="assetReconciliationChanged($event)"></asset-reconciliation>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>